import React from 'react'
import PageLayout from '../templates/PageLayout';
import ReactMarkdown from 'react-markdown';

const text =
    "### Two Pos-Doctoral Fellowships (one year, renewable) at NOVA LINCS/FCT NOVA and " +
    "the Collaborative Laboratory with our industrial partner OutSystems.\n\n"+

    "The research programme takes place within the Software Systems research group of NOVA LINCS " +
    "in collaboration with R&D members of OutSystems, a Portuguese company that is responsible for " +
    "a globally known low-code platform for rapid application development.\n\n"+

    "Two post doctoral positions are available under the scope of our project CLAY-An Environment " +
    "for live Construction of Trustworthy Software, and the collaborative laboratory between NOVALINCS " +
    "and Outsystems that focuses on the development new programming models and tools.\n\n"+

    "The goal is to design new programming models, associated verification techniques, and/or " +
    "programming environments to support the live construction of trustworthy applications in " +
    "the web/cloud domain. Possible areas of focus include the development of behavioural type " +
    "systems for safely updating structured states and processes, reasoning techniques for distributed " +
    "data management, certified runtime infrastructures, domain specific logics and algorithms " +
    "for contracts and policies. This collaborative effort seeks to run the extra mile to transpose " +
    "theoretical results into a well establish development product like the OutSystems platform.\n\n"+

    "To apply for this position, the candidate is required to have a strong computer science or " +
    "informatics background at the PhD level, and a proven publication track record in one or " +
    "more of the following areas: principles of programming languages, programming language " +
    "design and implementation, software verification, and program analysis. We welcome " +
    "candidates with a background on principles and theory (programming models, type systems, " +
    "verification, semantics), or systems implementation (language design, runtime systems, compilers). " +
    "We expect research results to be published at premier programming languages and systems conferences" +
    " and journals, and give preference to candidates that are motivated to collaborate with " +
    "industrial partners.\n\n"+

    "If you are interested please contact João Costa Seco (joao.seco@fct.unl.pt) until June 30, 2018";

const Positions = (props) => {
    return (
        <PageLayout>
            <h2>Open positions</h2>
            <ReactMarkdown source={text}/>
        </PageLayout>);
}

export default Positions;